var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 1.0625C0.304688 1.0625 0.1875 1.20312 0.1875 1.34375V4.71875C0.1875 4.88281 0.304688 5 0.46875 5H3.84375C3.98438 5 4.125 4.88281 4.125 4.71875V4.48438C4.125 4.34375 3.98438 4.20312 3.84375 4.20312H1.52344C2.36719 2.60938 4.05469 1.48438 6 1.48438C8.76562 1.48438 11.0156 3.75781 11.0156 6.5C11.0156 9.28906 8.74219 11.5156 6 11.5156C4.6875 11.5156 3.51562 11.0469 2.625 10.25C2.53125 10.1328 2.34375 10.1562 2.25 10.25L2.08594 10.4141C1.96875 10.5312 1.96875 10.7188 2.08594 10.8359C3.11719 11.75 4.5 12.3125 6 12.3125C9.1875 12.3125 11.7891 9.73438 11.8125 6.52344C11.8125 3.33594 9.21094 0.710938 6 0.710938C3.86719 0.6875 1.99219 1.85938 0.984375 3.57031V1.34375C0.984375 1.20312 0.84375 1.0625 0.703125 1.0625H0.46875ZM7.99219 8.46875L8.10938 8.30469C8.20312 8.1875 8.17969 8 8.03906 7.92969L6.375 6.6875V3.21875C6.375 3.07812 6.23438 2.9375 6.09375 2.9375H5.90625C5.74219 2.9375 5.625 3.07812 5.625 3.21875V7.08594L7.59375 8.51562C7.73438 8.60938 7.89844 8.58594 7.99219 8.46875Z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHistory);
export default __webpack_public_path__ + "static/media/ico-history.68ecac834f57f317f374c502d59d77c6.svg";
export { ForwardRef as ReactComponent };